// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
export const validProducts: string[] = [
	'jira',
	'confluence',
	'townsquare',
	'loom',
	'atlassianStudio',
	'bitbucket',
	'admin',
	'trello',
	'analyticsVisualizationPlatform',
];
